import {
  B_12,
  BANNER_DEFAULTS,
  hideB12Props,
} from "@stadium/shared/src/helpers/plasmic/static-slices";

export const B12_PLASMIC_PROPS = {
  b12Heading: {
    type: "string",
    defaultValue: BANNER_DEFAULTS[B_12].heading,
    description: "Main heading (B12 only)",
    hidden: hideB12Props,
  },
  b12Description: {
    type: "string",
    defaultValue: BANNER_DEFAULTS[B_12].description,
    description: "Description text (B12 only)",
    hidden: hideB12Props,
  },
  b12PrimaryButtonText: {
    type: "string",
    defaultValue: BANNER_DEFAULTS[B_12].primaryButtonText,
    description: "Primary CTA button text (B12 only)",
    hidden: hideB12Props,
  },
  b12PrimaryButtonUrl: {
    type: "string",
    defaultValue: BANNER_DEFAULTS[B_12].primaryButtonUrl,
    description: "Primary CTA button URL (B12 only)",
    hidden: hideB12Props,
  },
  b12MobileImg: {
    type: "imageUrl",
    defaultValue: BANNER_DEFAULTS[B_12].mobileImg,
    description: "Mobile/tablet image (B12 only)",
    hidden: hideB12Props,
  },
  b12DesktopImg: {
    type: "imageUrl",
    defaultValue: BANNER_DEFAULTS[B_12].desktopImg,
    description: "Desktop image (B12 only)",
    hidden: hideB12Props,
  },
  b12ImageAlt: {
    type: "string",
    defaultValue: BANNER_DEFAULTS[B_12].imageAlt,
    description: "Image alt text for desktop and mobile (B12 only)",
    hidden: hideB12Props,
  },
};
